import { Dispatch, SetStateAction, useEffect } from "react";
import { Collapse } from "reactstrap";
import { useAtom } from "jotai";

import PageViewDashboard from "../../PageViewDashboard/PageViewDashboard";
import { insightsOpenAtom } from "../../../../views/pages/PageView";
import { SelectedChart } from "../../../Widgets/WidgetTypes";
import { Page } from "../../../../types/GlobalInterfaces";
import { View } from "../../../../types/PageInterfaces";
import { EditDashboard } from "../../PageViewHeader";

interface Props {
  ChildComponentRendered: JSX.Element;
  page: Page;
  view: View;
  parentViewID: string | undefined;
  record: Record<string, any> | undefined;
  query: any;
  selectedGroup: SelectedChart | undefined;
  setSelectedGroup: Dispatch<SetStateAction<SelectedChart | undefined>>;
  showInsights?: boolean;
}

export default function PageViewInsights({
  ChildComponentRendered,
  page,
  view,
  parentViewID,
  record,
  query,
  selectedGroup,
  setSelectedGroup,
}: Props) {
  const [showInsights, setShownInsights] = useAtom(insightsOpenAtom);

  useEffect(() => {
    if (view?.id && showInsights?.[view.id] === undefined) {
      setShownInsights((prev) => ({
        ...prev,
        [view.id]: true,
      }));
    }
  }, [view?.id, showInsights, setShownInsights]);

  return (
    <div>
      {view && (
        <div className="tw:flex tw:items-center tw:mt-6 tw:mb-3">
          <h4 className="tw:mb-0">Insights</h4>
          <div className="tw:ml-auto tw:mr-0">
            <EditDashboard
              view={view}
              showInsights={showInsights?.[view?.id]}
              toggleInsights={() =>
                setShownInsights((prev) => ({
                  ...prev,
                  [view.id]: prev.hasOwnProperty(view.id)
                    ? !prev[view.id]
                    : false,
                }))
              }
            />
          </div>
        </div>
      )}
      <Collapse isOpen={showInsights?.[view?.id]}>
        <PageViewDashboard
          page={page}
          view={view}
          parentViewID={parentViewID}
          record={record}
          insightsModule={view?.ModuleAPIName}
          topLevelFilters={query?.Filters}
          onSelectGroup={onSelectGroup}
          selectedGroup={selectedGroup}
        />
      </Collapse>

      {ChildComponentRendered}
    </div>
  );

  function onSelectGroup(newSelectedGroup: SelectedChart | undefined) {
    if (newSelectedGroup === undefined) {
      return setSelectedGroup(undefined);
    }

    if (JSON.stringify(newSelectedGroup) === JSON.stringify(selectedGroup)) {
      return setSelectedGroup(undefined);
    }

    setSelectedGroup(newSelectedGroup);
  }
}
